import React, { useEffect, useState } from "react";
import OverviewMain from "./OverviewMain";
import Loader from "../../Helper/Loaders/Loader";
import ScreenContainer from "../../Components/ScreenContainer";
import { getPagesMetaData } from "../../Api/Api";
import CODE from "../../Static/Constants/StatusCodes";

export default function Overview(props) {

  const [pageContent, setPageContent] = useState({
    mounted: false,
  });

  const [isLoading, setIsLoading] = useState(true);

  const setPageData = async () => {
    const pageName = 'fleetHomePage'
    const res = await getPagesMetaData(pageName)

    if (res && res?.responseStatus?.code === CODE.SUCCESS) {
      const pageData = res.response?.response
      setPageContent(pageData)
    }
    setIsLoading(false);
  }

  useEffect(() => {
    setPageData();
  }, []);

  if (isLoading) {
    return <Loader />
  }

  return (
    <ScreenContainer pagesContent={pageContent}>
      <OverviewMain />
    </ScreenContainer>
  )
}
